import { memo } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import artConnectImg from "../assets/img/artconnect.png";
import voiceAssistantImg from "../assets/img/voice-assistant.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = memo(() => {
  const projects = [
    {
      title: "Cloud-Based E-Commerce Platform",
      description: "Designed and implemented a full-stack e-commerce web app using Django and PostgreSQL, deployed on a cloud environment.",
      imgUrl: projImg1,
      category: "web"
    },
    {
      title: "Machine Learning for Industry",
      description: "Developed forecasting and classification algorithms in Python for Schaeffler Group, including ontology analysis and automation.",
      imgUrl: projImg2,
      category: "ml"
    },
    {
      title: "Web Development",
      description: "Maintained and developed websites using JavaScript, PHP, HTML, and WordPress. Managed backend data and processes.",
      imgUrl: projImg3,
      category: "web"
    },
    {
      title: "Game Development",
      description: "Developed an adrenaline-fueled action-adventure game in Unity using C#. Engineered responsive combat mechanics, fluid movement, and innovative level design to deliver an immersive and thrilling gameplay experience.",
      imgUrl: projImg4,
      category: "game"
    },
    {
      title: "ArtConnect",
      description: "A React-based social platform where artists can share, follow, and sell their artwork in a vibrant creative community.",
      imgUrl: artConnectImg,
      category: "web"
    },
    {
      title: "VocalMind – Voice Assistant",
      description: "A Python-based desktop app that understands voice commands, automates tasks, and provides natural voice responses using STT & TTS technologies.",
      imgUrl: voiceAssistantImg,
      category: "ml"
    }
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col xs={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2 className="text-center">Projects</h2>
                  <p className="text-center">
                    A selection of my recent academic and professional projects involving full-stack development, machine learning, and game development.
                  </p>

                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="justify-content-center nav-pills mb-5"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">All</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Machine Learning</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="fourth">Game</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Web Dev</Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content>
                      {/* All */}
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => (
                            <ProjectCard key={index} {...project} />
                          ))}
                        </Row>
                      </Tab.Pane>

                      {/* Machine Learning */}
                      <Tab.Pane eventKey="second">
                        <Row>
                          {projects
                            .filter(p => p.category === "ml")
                            .map((project, index) => (
                              <ProjectCard key={index} {...project} />
                            ))}
                        </Row>
                      </Tab.Pane>

                      {/* Web Dev */}
                      <Tab.Pane eventKey="third">
                        <Row>
                          {projects
                            .filter(p => p.category === "web")
                            .map((project, index) => (
                              <ProjectCard key={index} {...project} />
                            ))}
                        </Row>
                      </Tab.Pane>

                      {/* Game */}
                      <Tab.Pane eventKey="fourth">
                        <Row>
                          {projects
                            .filter(p => p.category === "game")
                            .map((project, index) => (
                              <ProjectCard key={index} {...project} />
                            ))}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>

      {/* Lazy load background image */}
      <img
        className="background-image-right"
        src={colorSharp2}
        alt="background"
        loading="lazy"
      />
    </section>
  );
});
